import { ReactElement } from 'react';
import { CompoundComponent } from 'ia-react-core/~/interfaces/CompoundComponent';

export const BeforeHeader = ({ children }: CompoundComponent) => children as ReactElement;
BeforeHeader.type = Symbol('SideNavLayout.BeforeHeader');

export const Content = ({ children }: CompoundComponent) => children as ReactElement;
Content.type = Symbol('SideNavLayout.Content');

export const DrawerFooter = ({ children }: CompoundComponent) => children as ReactElement;
DrawerFooter.type = Symbol('SideNavLayout.DrawerFooter');

export const HeaderRightContent = ({ children }: CompoundComponent) => children as ReactElement;
HeaderRightContent.type = Symbol('SideNavLayout.HeaderRightContent');
